import React from 'react';
import T from 'prop-types';

import { FILTER_TAB_LIST } from '@dmi/shared/redux/Calculators/Amortize/constants';

import { FilterGroup } from '../../../base_ui';
import { FilterWrapper, StyledPrimaryDivider } from './styledComponents';

const Filter = ({ handleChangeAdjustmentFilter, selectedAdjustmentFilter }) => (
  <FilterWrapper>
    <FilterGroup
      filterList={FILTER_TAB_LIST}
      handleOnPress={handleChangeAdjustmentFilter}
      selectedFilter={selectedAdjustmentFilter}
      showsHorizontalScrollIndicator={false}
    />
    <StyledPrimaryDivider />
  </FilterWrapper>
);

Filter.propTypes = {
  handleChangeAdjustmentFilter: T.func.isRequired,
  selectedAdjustmentFilter: T.string.isRequired,
};

export default Filter;
